<template>
    <div class="employerDetails">

        <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
              <div class="col-md-5">
                <p class="u-back"><a href="javascript: void(0)" @click="backToEmployerList()"><i class="fa fa-chevron-left"></i> Back</a></p>
              </div>
              <div class="col-md-7 text-right">
                <ul class="o-filter-area">
                  <li v-if="getPower('editEmployer')"><a @click="gotoEditEmployer()" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</a></li>
                </ul>
              </div>
              <div class="col-md-12 c-user">
                <div class="c-user__profile-pic u-mar-right-10">
                    <img v-if="detailEmployer && detailEmployer.employer && detailEmployer.employer.image !='' && detailEmployer.employer.image !=null" :src="detailEmployer.employer.image" id='img-upload' />
                    <img v-else  src="static/assets/images/user1.png" id='img-upload' />
                </div>
                <div class="c-user__profile-details">
                  <h4 class="h1">{{detailEmployer? detailEmployer.employer.name : ''}}</h4>
                  <p>Email ID: {{detailEmployer ? detailEmployer.employer.email : ''}}</p>
                  <ul :class="{'isDisabled':!getPower('editEmployer')}" class="employer-profile-switch">
                    <li>
                      <div class="custom-col text-center">
                        <div class="o-pub">
                          <div class="radio">
                            <label>
                              <input type="radio" @change="updateAccess()" name="o11" value="no_access" v-model="accessPermitions">
                              <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                              No Access
                            </label>
                          </div>
                          <!-- <label>View Only</label>
                          <div class="toggle-btn">
                            <el-switch
                                style="display: block"
                                v-model="accessPermitions"
                                @change="updateAccess()"
                                active-color="#13ce66"
                                inactive-color="#dcdfe6"
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                          </div> -->
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="custom-col text-center">
                        <div class="o-pub">
                          <div class="radio">
                            <label>
                              <input type="radio" @change="updateAccess()" name="o11" value="view_access" v-model="accessPermitions">
                              <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                              View Only
                            </label>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="custom-col text-center">
                        <div class="o-pub">
                          <div class="radio">
                            <label>
                              <input type="radio" @change="updateAccess()" name="o11" value="create_edit" v-model="accessPermitions">
                              <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                              Create/Edit
                            </label>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="custom-col text-center">
                        <div class="o-pub">
                          <div class="radio">
                            <label>
                              <input type="radio" @change="updateAccess()" name="o11" value="api_access" v-model="accessPermitions">
                              <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                              API Access
                            </label>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Contact Persons:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Contact Person Name</h5>
                            <p>
                              {{detailEmployer ? detailEmployer.employer.employer_users[0].user.first_name : '--'}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Email</h5>
                            <p>
                              {{detailEmployer ? detailEmployer.employer.employer_users[0].user.email : '--'}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Phone</h5>
                            <div v-if="detailEmployer">
                                <p v-if="phone.label=='Primary phone'" v-for="(phone,phIndex) in detailEmployer.employer.employer_users[0].user.phones" :key="phIndex">
                                    <!-- {{phone.phone_number}} -->
                                    <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                        {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                    </a>
                                </p>  
                            </div>
                            
                          </div>
                          <div class="col-sm-3">
                            <h5>Client Access</h5>
                            <p>
                              <span v-for="(client,cliIndex) in associateClientList" :key="cliIndex" v-if="client.status_id!=null">
                                {{client.client.subdomain}}
                              </span>
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Phone & Fax:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Primary Phone No.</h5>
                            <div v-if="detailEmployer">
                                <p v-if="phone.label=='Primary phone'" v-for="(phone,phIndex) in detailEmployer.employer.phones" :key="phIndex">
                                    <!-- {{phone.phone_number}} -->
                                  <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                      {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                  </a>
                                </p>  
                            </div>
                            <p v-else>--</p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Secondary Phone No.</h5>
                            <div v-if="detailEmployer">
                                <p v-if="phone.label=='Secondary phone'" v-for="(phone,phIndex) in detailEmployer.employer.phones" :key="phIndex">
                                    <!-- {{phone.phone_number}} -->
                                    <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                        {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                    </a>
                                </p>  
                            </div>
                            <p v-else>--</p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Cell Phone</h5>
                            <div v-if="detailEmployer">
                                <p v-if="phone.label=='Cell phone'" v-for="(phone,phIndex) in detailEmployer.employer.phones" :key="phIndex">
                                    <!-- {{phone.phone_number}} -->
                                    <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                        {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                    </a>
                                </p>  
                            </div>
                            <p v-else>--</p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Fax</h5>
                           <div v-if="detailEmployer">
                                <p v-if="phone.label=='Fax'" v-for="(phone,phIndex) in detailEmployer.employer.phones" :key="phIndex">
                                    <!-- {{phone.phone_number}} -->
                                    <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                        {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                    </a>
                                </p>  
                            </div>
                            <p v-else>--</p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Address:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Street</h5>
                            <p v-if="detailEmployer && detailEmployer.employer.addresses && detailEmployer.employer.addresses.length>0">
                              {{detailEmployer.employer.addresses[0].address}}
                            </p>
                            <p v-else>--</p>
                          </div>
                          <div class="col-sm-3">
                            <h5>City</h5>
                            <p v-if="detailEmployer && detailEmployer.employer.addresses && detailEmployer.employer.addresses.length>0">
                              {{detailEmployer.employer.addresses[0].municipality}}
                            </p>
                            <p v-else>--</p>
                          </div>
                          <div class="col-sm-3">
                            <h5>State</h5>
                            <p v-if="detailEmployer && detailEmployer.employer.addresses && detailEmployer.employer.addresses.length>0">
                              {{detailEmployer.employer.addresses[0].state_province}}
                            </p>
                            <p v-else>--</p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Zip</h5>
                            <p v-if="detailEmployer && detailEmployer.employer.addresses && detailEmployer.employer.addresses.length>0">
                              {{detailEmployer.employer.addresses[0].postcode}}
                            </p>
                            <p v-else>--</p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!-- /Main Body Content area -->
    </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';

    export default {
        data() {
            return {
                accessPermitions:null,
                detailEmployer:null,
                associateClientList:null,
            }
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
          getClientContactFormat(phone) {
              phone = phone ? phone.toString() : '';
              phone = phone.replace(/-/g, "");
              phone = phone.replace(/ /g, "");
              phone = phone.replace("(", "");
              phone = phone.replace(")", "");
              let result = '';
              if(phone&&phone.length==10) { 
                  // console.log(phone);
                  result = '+1'+phone;
              }else if(phone&&phone.length==11) {
                  // console.log(phone);
                  result = '+' + phone;
              }else if(phone&&phone.length) {
                  result = phone;
              }
              return result;
              // return phone;
          },
          getPower(data) {
              return dateTimeConvert.checkAccess(data);
          },
          getEmployerClient(){
            service.get('employer/'+this.detailEmployer.employer.id+'/getEmployerClientAssociation', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
            })
            .then((res) => {
                this.associateClientList = res.data.result;
                //console.log(this.associateClientList);
            }).catch((err) => {
                console.log(err);
            });
          },
          updateAccess(){ 
            service.put('employer/' + atob(this.$route.params.employerId)+'/updateClientEmployersAccess', {'accessType': this.accessPermitions}, {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).
            then((res) => {
                this.$Progress.finish();
                this.$notify({
                    title: this.$t('success'),
                    message: 'Employer access updated successfully.',
                    type: 'success'
                });
                this.empDetails();
            }).catch((err) => {
                console.log(err);
            });
          },
          getDate(str) {
              return dateTimeConvert.globalDate(str);
          },
          getTime(dateTime) {
              return dateTimeConvert.globalTime(dateTime);
          },
          empDetails() {
              this.$Progress.start();
              service.get('employer/' + atob(this.$route.params.employerId)+'/getClientEmployer', {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
                  'cs3-context-clientId': this.userClientID
              }).
              then((res) => {

                this.detailEmployer = res.data.result;
                if(this.detailEmployer.status==null)
                  this.accessPermitions="no_access";
                switch(this.detailEmployer.status.name){
                    case 'View Access':
                        this.accessPermitions="view_access";
                        break;
                    case 'Create Edit Access':
                        this.accessPermitions="create_edit";
                        break;
                    case 'Api Access':
                        this.accessPermitions="api_access";  
                        break;
                    case 'No Access':
                        this.accessPermitions="no_access";  
                        break;
                    default:
                      // console.log('Access type not found');
                }
                  this.$Progress.finish();
                  this.getEmployerClient();
                  // this.accessPermitions.view=this.detailEmployer.view_access.toString();
                  // this.accessPermitions.createEdit=this.detailEmployer.create_edit.toString();
                  // this.accessPermitions.api=this.detailEmployer.api_access.toString();
              }).catch((err) => {
                  console.log(err);
              });
          },
          toggleHeader(id) {

              //console.log(id);
              if ($('#' + id).children().hasClass("fa-plus-circle")) {
                  //console.log("open");
                  $('#' + id).parent().addClass('js-active-togg');
                  $('#' + id).children().removeClass('fa-plus-circle').addClass('fa-minus-circle');
                  $('#' + id).siblings(".o-toggle-content").children(".js-note-txt-expand").addClass("js-togg-expand-height");
              } else {
                  //console.log('close');
                  $('#' + id).parent().removeClass('js-active-togg');
                  $('#' + id).children().removeClass('fa-minus-circle').addClass('fa-plus-circle');
                  $('#' + id).siblings(".o-toggle-content").find(".js-note-txt-expand").removeClass("js-togg-expand-height");
              }
          },
          backToEmployerList() {
              this.$router.push({
                  path: `/employerList`
              });
          },
          gotoEditEmployer() {
            // console.log(this.detailEmployer.employer_id);
              this.$router.push({
                  path: `/editEmployerClient/`+btoa(this.detailEmployer.employer_id)
              });
          },

          // editEmployer(employer) {
          //     console.log(employer);
          //     this.$router.push({
          //         path: `/editEmployerClient/`+btoa(employer.employer_id)
          //     });
          // },

          phoneNumberCheck(phone_number, type) {
              let self = this;
              let primaryPhone = "";
              if (phone_number) {
                  phone_number.forEach(function(employerphone) {
                      if (employerphone.label == type) {
                          //console.log(employerphone.label);
                          primaryPhone = employerphone.phone_number;
                      }
                  });
              }
              return primaryPhone;
          },
        },
        created() {
            this.empDetails();

        }
    }

</script>
<style scoped>
  .phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
  }
  .radio label, .checkbox label {
    padding: 0px;
  }
  .employer-profile-switch {
    margin-bottom: 0px;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/employers/employerDetails.vue